var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success container_padding"},[_c('div',{staticClass:"success-box"},[_c('img',{attrs:{"src":require("../../assets/web/success.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.$t('message.submit_success')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }